export default __webpack_public_path__ + "img/1_5-4538d2ff.png";